import React from 'react'
import styled from '@emotion/styled'
import { Colors, Shapes } from 'src/components/theme'
import { HelpMarkdown } from 'src/components/help-markdown'
import { DarkTooltip } from 'src/components/tooltip/dark-tooltip'

const ENTER_DELAY = 1000
const LEAVE_DELAY = 200

type HelpTooltipProps = {
  file?: string
  children: React.ReactElement
  placement?:
    | 'bottom-end'
    | 'bottom-start'
    | 'bottom'
    | 'left-end'
    | 'left-start'
    | 'left'
    | 'right-end'
    | 'right-start'
    | 'right'
    | 'top-end'
    | 'top-start'
    | 'top'
  alwaysVisible?: boolean
  immediate?: boolean
  disable?: boolean
}

type HelpTooltipContentProps = {
  file?: string
}

const TooltipContentWrapper = styled.div`
  max-height: 150px;
  overflow-y: scroll;
  overflow-y: overlay;

  &::-webkit-scrollbar,
  .scrollable-y::-webkit-scrollbar {
    width: 2px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: ${Colors.textLight};
    border-radius: ${Shapes.borderRadius}px;
  }

  &::-webkit-scrollbar-track {
    background-color: rgba(255, 255, 255, 0.1);
  }

  a {
    color: inherit;
    text-decoration: underline;

    &:hover {
      color: ${Colors.textWhite};
    }
  }
`

const HelpTooltipContent = (props: HelpTooltipContentProps) => {
  const { file } = props

  if (!file) {
    return null
  }

  return (
    <TooltipContentWrapper>
      <HelpMarkdown file={file} />
    </TooltipContentWrapper>
  )
}

// this is some dubm stuff you need to do for material-ui and typescript doesn't like it
// https://mui.com/components/tooltips/#custom-child-element
const TooltipWrapper = React.forwardRef(function Thing(props: any, ref) {
  return (
    <span
      {...props}
      ref={ref as any}
      style={{
        display: 'flex',
        ...props.style,
      }}>
      {props.children}
    </span>
  )
}) as any

export const HelpTooltip = (props: HelpTooltipProps) => {
  const { children, alwaysVisible, placement, immediate, file, disable } = props

  const enterDelay = immediate ? 0 : ENTER_DELAY

  if (disable || !file) {
    return children
  }

  return (
    <DarkTooltip
      arrow
      open={alwaysVisible}
      placement={placement}
      title={<HelpTooltipContent {...props} />}
      enterDelay={enterDelay}
      enterNextDelay={ENTER_DELAY}
      leaveDelay={LEAVE_DELAY}>
      <TooltipWrapper id={`help-${file}`}>{children}</TooltipWrapper>
    </DarkTooltip>
  )
}
